import Notify from './Notify';

export default Notify;
